// InlineCommentForm — shared entrance animation for the small textarea +
// Cancel/Submit comment forms. Used both as a Phoenix LiveView hook
// (heex callsite via `phx-hook="InlineCommentForm"`) and as a plain
// helper called from JS-injected forms (diff-inline-overlay,
// code-browser blob comments) so all three surfaces share one motion
// language.
//
// Animation mirrors `dropdownAnimateIn` in ./dropdown.ts: short
// fade + slide + rotateX, ~220 ms power3.out — the same easing the
// nav dropdowns use, so the inline reply box doesn't feel like a
// stranger inside an otherwise consistent UI.

import gsap from "gsap";
import {
  POPOVER_HIDDEN_VARS,
  POPOVER_VISIBLE_VARS,
  ensurePerspective,
} from "./animation-perspective";
import type { LiveViewHook } from "./types";

export const animateInlineCommentFormIn = (el: HTMLElement): void => {
  gsap.killTweensOf(el);
  ensurePerspective(el);
  gsap.fromTo(
    el,
    { ...POPOVER_HIDDEN_VARS },
    {
      ...POPOVER_VISIBLE_VARS,
      duration: 0.22,
      ease: "power3.out",
      clearProps: "transform",
    },
  );
};

export const InlineCommentForm = {
  mounted(this: LiveViewHook<never>): void {
    animateInlineCommentFormIn(this.el);
  },
};
